<template>
  <b-modal
    id="modal-input"
    centered
    :title="header"
    :hide-header="!header"
    hide-footer
    :size="size || 'md'"
    :no-close-on-backdrop="true"
  >
    <b-form @submit.prevent="submit">
      <b-form-group
        v-for="field in fields"
        :key="field.name"
        :label="field.label"
        :label-for="`input-value-${field.name}`"
      >
        <b-form-input
          :id="`input-value-${field.name}`"
          v-model="field.value"
          v-validate="{ required: true }"
          type="text"
          :placeholder="field.label"
          :data-vv-name="field.label"
        ></b-form-input>
      </b-form-group>

      <b-row>
        <b-col class="text-right">
          <b-btn variant="primary" type="submit">Save</b-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: "InputSingleModal",
  props: {
    header: {
      type: String,
      required: false,
      default: null
    },
    fields: {
      type: Array,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: null
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error"
          });
          return false;
        }

        this.$bvModal.hide("modal-input");
        this.$emit("submit", this.fields);
      });
    }
  }
};
</script>
